export default __webpack_public_path__ + "static/media/design.8ecb3043.svg";